export type Option = {
  label: string;
  value: string;
};

export type JobFilter = {
  department: string | null;
  location: string | null;
  status: string | null;
};

export const emptyJobFilter: JobFilter = {
  department: null,
  location: null,
  status: null,
};
